// Fenêtres modales 
var triggers = document.querySelectorAll('.open-modal');

triggers.forEach(function(trigger) {

  var modalId = trigger.getAttribute('data-modal');
  var dialog = document.querySelector(modalId);
  var close = dialog.querySelector('.modal__close-btn');

  function openDialog() {
    dialog.setAttribute('open', '');
    close.focus();
    close.addEventListener('keydown', function(e) {
      if (e.keyCode == 9) {
        e.preventDefault();
      }
    });
    document.addEventListener('keydown', addESC);
  }

  function closeDialog() {
    dialog.removeAttribute('open');
    trigger.focus();      
    document.removeEventListener('keydown', addESC);
  }

  var addESC = function(e) {
    if (e.keyCode == 27) {
      closeDialog();
    } 
  };

  trigger.addEventListener('click', function() {
    openDialog();
  });

  close.addEventListener('click', function() {
    closeDialog();
  });
})
